import { useState, useEffect } from 'react';
import { Stack } from '@kiwicom/orbit-components';
import PasswordValidationBox from '@kiwicom/nitro/lib/components/MagicLogin/components/screens/CreateAccount/PasswordValidationBox';
import { PASSWORD_SCORE_TO_STRENGTH } from '@kiwicom/nitro/lib/components/MagicLogin/consts/password';
import { useFormContext } from 'react-hook-form';
import { passwordScore } from '@kiwicom/nitro/lib/services/input/validators';
import { FormattedMessage } from 'react-intl';

import PasswordInput from './PasswordInput';

const newPasswordName = 'newPassword';
const confirmedNewPassword = 'confirmedNewPassword';

const NewPasswordForm = (): JSX.Element => {
  const {
    formState: { errors },
    watch,
  } = useFormContext();
  const [passswordStrength, setPasswordStrength] = useState(PASSWORD_SCORE_TO_STRENGTH['0']);
  const newPassword = watch(newPasswordName);
  useEffect(() => {
    const userInput = ['skypicker', 'kiwi'];
    // Score from 0 to 4 according to zxcvbn
    const score = passwordScore(newPassword ?? '', userInput);
    const computedPasswordStrength = PASSWORD_SCORE_TO_STRENGTH[String(score)];
    setPasswordStrength(computedPasswordStrength || 'WEAK');
  }, [newPassword]);

  return (
    <Stack>
      <Stack spacing={errors.newPassword == null ? 'XSmall' : 'medium'}>
        <PasswordInput
          name={newPasswordName}
          label={
            <FormattedMessage
              id="account_v2.settings.account_settings.login.set_password_modal.new_password_input"
              defaultMessage="Create new password"
            />
          }
        />
        <PasswordValidationBox passwordStrength={passswordStrength} />
      </Stack>
      <PasswordInput
        name={confirmedNewPassword}
        label={
          <FormattedMessage
            id="account_v2.settings.account_settings.login.set_password_modal.confirm_new_password_input"
            defaultMessage="Confirm new password"
          />
        }
      />
    </Stack>
  );
};

export default NewPasswordForm;
